// Components==============
import Button from 'components/UI/Button/Button';
import DotsMenu from 'components/UI/DotsMenu/DotsMenu';
import MobileSharecodeButton from 'components/UI/MobileSharecodeButton/MobileSharecodeButton';
import ShareCodeButton from 'components/UI/ShareCodeButton/ShareCodeButton';
import { AnimatePresence } from 'framer-motion';
import { useMediaQ } from 'hooks/useMediaQ';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { TrainingDetailsContext } from 'pages/Workspace/TrainingDetails/TrainingDetails';
import React, { useContext, useState } from 'react';
import DeleteModal from './components/DeleteModal/DeleteModal';
import FinishConceptModal from './components/FinishConceptModal/FinishConceptModal';
import SettingsModal from './components/SettingsModal/SettingsModal';
import './TopRight.module.scss';
// =========================

export default function TopRight({ training }: { training?: TrainingEntity }) {
  const translate = useTranslate();
  const query = useMediaQ('min', 1024);
  const userId = useRedux((state) => state.authentication?.user?.id);
  const isTeacher = usePermission(['Docent', 'super-admin']);

  const [finishConceptModalIsOpen, setFinishConceptModalIsOpen] = useState(
    false
  );
  const [settingsModalIsOpen, setSettingsModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

  const { handleDuplicate, handleEdit } = useContext(TrainingDetailsContext);
  const handleFinishConcept = () => setFinishConceptModalIsOpen(true);
  const handleSettings = () => setSettingsModalIsOpen(true);
  const handleDelete = () => setDeleteModalIsOpen(true);

  const isOwner = training?.owner_id === userId;

  const shareCodeCondition = !!(isOwner && training?.is_published);
  const finishConceptCondition = !!(
    isTeacher &&
    isOwner &&
    !training?.is_published
  );
  const publishCondition = !!(
    isTeacher &&
    isOwner &&
    training?.is_published &&
    training.visibility === 'private' &&
    !training.cloned_from_id
  );
  const settingsCondition = !!(
    isTeacher &&
    isOwner &&
    training?.is_published &&
    training.visibility !== 'private'
  );
  const duplicateCondition = !!(isTeacher && isOwner);
  const addLessonsSessionCondition = !!(
    isTeacher &&
    isOwner &&
    training?.is_published
  );
  const editCondition = !!(isTeacher && isOwner && !training?.is_published);

  return (
    <>
      <div styleName="wrapper">
        {query ? (
          <>
            {shareCodeCondition && (
              <ShareCodeButton
                sharecode={training?.share_code}
                type="courses"
              />
            )}
            {finishConceptCondition && (
              <Button color="grey" onClick={handleFinishConcept}>
                {translate('general.terms.finalize-draft')}
              </Button>
            )}
            {publishCondition && (
              <Button color="grey" onClick={handleSettings}>
                {translate('general.terms.publish')}
              </Button>
            )}
            {settingsCondition && (
              <Button color="grey" onClick={handleSettings}>
                {translate('course.publish-settings.title')}
              </Button>
            )}
            <DotsMenu>
              {editCondition && (
                <button type="button" onClick={handleEdit}>
                  {translate('course.actions.edit-course')}
                </button>
              )}
              {duplicateCondition && (
                <button type="button" onClick={handleDuplicate}>
                  {translate('course.actions.duplicate-course')}
                </button>
              )}
              {addLessonsSessionCondition && (
                <button type="button" onClick={handleEdit}>
                  {translate('course.actions.add-lessons-and-sessions')}
                </button>
              )}
              <button type="button" styleName="delete" onClick={handleDelete}>
                {translate('course.actions.delete-course')}
              </button>
            </DotsMenu>
          </>
        ) : (
          <DotsMenu>
            {finishConceptCondition && (
              <button type="button" onClick={handleFinishConcept}>
                {translate('general.terms.finalize-draft')}
              </button>
            )}
            {publishCondition && (
              <button type="button" onClick={handleSettings}>
                {translate('general.terms.publish')}
              </button>
            )}
            {settingsCondition && (
              <button type="button" onClick={handleSettings}>
                {translate('course.publish-settings.title')}
              </button>
            )}
            {!!(shareCodeCondition && training?.share_code) && (
              <MobileSharecodeButton sharecode={training.share_code} />
            )}
            <button type="button" styleName="delete" onClick={handleDelete}>
              {translate('course.actions.delete-course')}
            </button>
          </DotsMenu>
        )}
      </div>
      <AnimatePresence>
        {finishConceptModalIsOpen && (
          <FinishConceptModal setModalIsOpen={setFinishConceptModalIsOpen} />
        )}
        {settingsModalIsOpen && (
          <SettingsModal setModalIsOpen={setSettingsModalIsOpen} />
        )}
        {deleteModalIsOpen && (
          <DeleteModal setModalIsOpen={setDeleteModalIsOpen} />
        )}
      </AnimatePresence>
    </>
  );
}
